export default __webpack_public_path__ + "static/media/viandesechebresaola.fa2350f8.jpg";